import MaintenanceWorkOrder from './MaintenanceWorkOrder.vue'

export default MaintenanceWorkOrder 


// WEBPACK FOOTER //
// ./src/pages/MaintenanceWorkOrder/index.js